import React from "react";
const AvatarModal = ({
  show,
  onHide,
  onSelect,
  avatars,
  isLoading,
  selectedAvatar,
}) => {
  return (
    <>
      {show && (
        <div
          className="modal fade custom-modal show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-scrollable modal-lg">
            <div className="modal-content custom-modal">
              <div className="modal-header custom-modal-header">
                <h5 className="modal-title">Choose Your Avatar</h5>
                <button
                  type="button"
                  className="btn-close-avatar-modal"
                  onClick={onHide}
                  aria-label="Close"
                >
                  ×
                </button>
              </div>
              <div className="modal-body custom-modal-body">
                {isLoading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading avatars...</p>
                  </div>
                ) : !Array.isArray(avatars) || avatars.length === 0 ? (
                  <div className="text-center py-5">
                    <div className="text-muted mb-3">
                      <i
                        className="bi bi-emoji-frown"
                        style={{ fontSize: "3rem" }}
                      ></i>
                    </div>
                    <h5>No avatars available</h5>
                    <p className="text-muted">Please try again later</p>
                  </div>
                ) : (
                  <div className="row" id="avatar_list">
                    {avatars.map((avatar) => (
                      <div
                        key={avatar.id}
                        className="col-md-2 mb-3 text-center position-relative"
                      >
                        <img
                          src={avatar.url}
                          alt={`Avatar ${avatar.id}`}
                          className="img-thumbnail cursor-pointer avatar-option"
                          onClick={() => onSelect(avatar.url)}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.05)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AvatarModal;
